var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 1.60001C6.93904 1.60001 5.92162 2.02143 5.17148 2.77158C4.42133 3.52172 3.9999 4.53914 3.9999 5.60001V7.20001C3.57556 7.20001 3.16859 7.36858 2.86853 7.66864C2.56847 7.96869 2.3999 8.37566 2.3999 8.80001V12.8C2.3999 13.2244 2.56847 13.6313 2.86853 13.9314C3.16859 14.2314 3.57556 14.4 3.9999 14.4H11.9999C12.4242 14.4 12.8312 14.2314 13.1313 13.9314C13.4313 13.6313 13.5999 13.2244 13.5999 12.8V8.80001C13.5999 8.37566 13.4313 7.96869 13.1313 7.66864C12.8312 7.36858 12.4242 7.20001 11.9999 7.20001H5.5999V5.60001C5.5997 5.01572 5.81266 4.45143 6.19883 4.01295C6.58501 3.57448 7.11788 3.29194 7.69751 3.21832C8.27714 3.1447 8.86371 3.28506 9.34724 3.61307C9.83077 3.94108 10.178 4.43422 10.3239 5.00001C10.3769 5.2055 10.5094 5.3815 10.6923 5.48929C10.7828 5.54267 10.8829 5.57769 10.987 5.59236C11.091 5.60704 11.197 5.60107 11.2987 5.57481C11.4005 5.54854 11.496 5.50249 11.58 5.43929C11.6639 5.37609 11.7346 5.29697 11.788 5.20645C11.8414 5.11593 11.8764 5.01579 11.8911 4.91173C11.9057 4.80768 11.8998 4.70175 11.8735 4.60001C11.6515 3.74142 11.1506 2.98088 10.4495 2.43787C9.74837 1.89487 8.88672 1.60014 7.9999 1.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/LockOpen.11603539ff89f06da536ea01cc1d26a3.svg";
export { ForwardRef as ReactComponent };